'use strict';

const bp = require('../util/breakpoints');

/**
 * @private
 * @function
 * @description Initialize jRespond
 */
function jResInit() {
    var jRes = jRespond([{ // eslint-disable-line
        label: 'xsmall',
        enter: 0,
        exit: bp.values.small - 1
    }, {
        label: 'small',
        enter: bp.values.small,
        exit: bp.values.medium - 1
    }, {
        label: 'medium',
        enter: bp.values.medium,
        exit: bp.values.large - 1
    }, {
        label: 'large',
        enter: bp.values.large,
        exit: bp.values.extraLarge - 1
    }, {
        label: 'extraLarge',
        enter: bp.values.extraLarge,
        exit: bp.values.extraExtraLarge - 1
    }, {
        label: 'extraExtraLarge',
        enter: bp.values.extraExtraLarge,
        exit: 10000
    }]);

    var $document = $(document);

    //set desktop as default
    jRes.isXSmall = false;
    jRes.isSmall = false;
    jRes.isMedium = false;
    jRes.isLarge = false;
    jRes.isExtraLarge = false;
    jRes.isExtraExtraLarge = false;

    // Run only once
    if (window.jResInitFlag === undefined) {
        window.jResInitFlag = true;
    }

    $document.on('viewportchange', (event, breakpointName) => {
        window.currentBreakpoint = breakpointName;
    });

    if (window.jResInitFlag) {
        jRes.addFunc([{
            breakpoint: 'xsmall',
            enter: function () {
                jRes.isXSmall = true;
                $document.trigger('viewportchange', ['xsmall']);
            },
            exit: function () {
                jRes.isXSmall = false;
            }
        }, {
            breakpoint: 'small',
            enter: function () {
                jRes.isSmall = true;
                $document.trigger('viewportchange', ['small']);
            },
            exit: function () {
                jRes.isSmall = false;
            }
        }, {
            breakpoint: 'medium',
            enter: function () {
                jRes.isMedium = true;
                $document.trigger('viewportchange', ['medium']);
            },
            exit: function () {
                jRes.isMedium = false;
            }
        }, {
            breakpoint: 'large',
            enter: function () {
                jRes.isLarge = true;
                $document.trigger('viewportchange', ['large']);
            },
            exit: function () {
                jRes.isLarge = false;
            }
        }, {
            breakpoint: 'extraLarge',
            enter: function () {
                jRes.isExtraLarge = true;
                $document.trigger('viewportchange', ['extraLarge']);
            },
            exit: function () {
                jRes.isExtraLarge = false;
            }
        }, {
            breakpoint: 'extraExtraLarge',
            enter: function () {
                jRes.isExtraExtraLarge = true;
                $document.trigger('viewportchange', ['extraExtraLarge']);
            },
            exit: function () {
                jRes.isExtraExtraLarge = false;
            }
        }]);

        window.jResInitFlag = false;
    }

    return jRes;
}

exports.init = jResInit;
